(() => {
  angular
    .module('complianceFrameworkApp.core')
    .filter('dateRange', dateRange);

  function dateRange(property, startDate, endDate) {
    return (item) => {
      if (item[property] === null) {
        return false;
      }

      /* eslint-disable no-undef */
      let itemDate = moment(item[property]);
      let parsedStartDate = moment(startDate, 'MM/DD/YYYY');
      let parsedEndDate = moment(endDate, 'MM/DD/YYYY');
      /* eslint-enable no-undef */

      return (itemDate >= parsedStartDate && itemDate <= parsedEndDate);
    };
  }
})();
